var option_default = {
  "option": "a9oGr",
  "user_choice": "_3iVfd",
  "check": "Ff06d",
  "image": "krO0q",
  "input": "z-Anl",
  "title": "KGMbv",
  "centered": "EUXII",
  "with_result": "WXPk3",
  "list": "yngm8",
  "with_image": "bTFz1",
  "progress": "_2tgSY",
  "progress_value": "s48Gu",
  "label": "v09Jo",
  "cta": "FLfh-",
  "adornment_icon": "BgVK2",
  "remove": "wnnlK",
  "removeButton": "xU-3U",
  "removeButtonIcon": "biIwv",
  "overlay": "dGQrk",
  "shown": "L00SP",
  "dark": "Xu8XR",
  "spinner": "I2-4M",
  "spin": "_5vYEF"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
